/* ODAVIA cart communication (drawer + cart page).
   Display only: money and discounts always come from Shopify.
   Config + translated strings come from sections/odavia-cart-progress.liquid
   ([data-odavia-cart-config]). Shipping is always free, so no threshold logic. */
(function(){
  var CFG={};
  try{ var cfgEl=document.querySelector('[data-odavia-cart-config]'); if(cfgEl) CFG=JSON.parse(cfgEl.textContent)||{}; }catch(e){ CFG={}; }
  var S=CFG.strings||{};
  var enableProgress=!!CFG.enableProgress;

  var TAG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 2.5 21.5 12 12 21.5 2.5 12V2.5z"/></svg>';
  var fmt=null;
  function money(cents){ if(!fmt){ var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'; fmt=new Intl.NumberFormat(document.documentElement.lang||'de',{style:'currency',currency:cur}); } return fmt.format(cents/100); }
  function esc(s){ var d=document.createElement('span'); d.textContent=s==null?'':String(s); return d.innerHTML.replace(/"/g,'&quot;'); }
  function str(key,n){ var s=S[key]; if(typeof s!=='string'||!s||/translation missing/i.test(s)) return ''; return s.split('[N]').join(String(n)); }
  function shortTitle(t){ t=String(t||''); var i=t.indexOf(' – '); if(i<0) i=t.indexOf(' — '); return i>0?t.slice(0,i):t; }

  function progressHTML(cart){
    var q=cart.item_count, hit1=q>=2, hit2=q>=3, hit3=q>=4;
    var fill=q>=4?100:(q>=3?50:0);
    var msg;
    if(q>=4) msg=str('tier20',0);
    else if(q===3) msg=str('tier15',1);
    else if(q===2) msg=str('tier10',1);
    else msg=str('tier0',Math.max(2-q,1));
    function dot(p,h){ return '<span class="odavia-prog__dot'+(h?' is-hit':'')+'" style="left:'+p+'%">'+TAG+'</span>'; }
    function lbl(p,n,h){ return '<span class="odavia-prog__lbl'+(h?' is-hit':'')+'" style="left:'+p+'%">'+n+' %</span>'; }
    return '<div class="odavia-prog" data-odavia-progress>'+
      (msg?'<div class="odavia-prog__head"><span class="odavia-prog__msg">'+esc(msg)+'</span></div>':'')+
      '<div class="odavia-prog__track" aria-hidden="true">'+
        '<span class="odavia-prog__rail"><span class="odavia-prog__fill" style="width:'+fill+'%"></span></span>'+
        dot(16.667,hit1)+dot(50,hit2)+dot(83.333,hit3)+
        lbl(16.667,'10',hit1)+lbl(50,'15',hit2)+lbl(83.333,'20',hit3)+
      '</div></div>';
  }

  function savedCents(cart){ var s=0; (cart.cart_level_discount_applications||[]).forEach(function(d){ s+=(d.total_allocated_amount||0); }); return s; }
  function savingsHTML(cart){
    var s=savedCents(cart); if(s<=0) return '';
    var label=S.savingsLabel&&!/translation missing/i.test(S.savingsLabel)?S.savingsLabel:'';
    return '<div class="odavia-foot-savings" data-odavia-savings><span class="odavia-foot-savings__l">'+esc(label)+'</span><b>−'+money(s)+'</b></div>';
  }

  /* Write only when the markup changed, so our own DOM writes do not
     re-trigger the MutationObservers below (that caused endless /cart.js polling). */
  function setHTML(el,html){ if(el.getAttribute('data-odavia-html')===html) return; el.innerHTML=html; el.setAttribute('data-odavia-html',html); }

  function ensureTopSlot(root){
    var slot=root.querySelector('.odavia-cart-top');
    if(!slot){ var header=root.querySelector('.drawer__header'); if(!header) return null;
      slot=document.createElement('div'); slot.className='odavia-cart-top'; header.insertAdjacentElement('afterend',slot); }
    return slot;
  }
  function injectDrawer(cart){
    var root=document.querySelector('#CartDrawer'); if(!root) return;
    if(cart.item_count===0){ var e=root.querySelector('.odavia-cart-top'); if(e) e.remove(); return; }
    if(enableProgress){ var slot=ensureTopSlot(root); if(slot) setHTML(slot,progressHTML(cart)); }
    else { var t0=root.querySelector('.odavia-cart-top'); if(t0) t0.remove(); }
    var foot=root.querySelector('.cart-drawer__footer');
    if(foot){
      var s=savingsHTML(cart), old=foot.querySelector('[data-odavia-savings]');
      if(!s){ if(old) old.remove(); }
      else if(!old || old.getAttribute('data-odavia-html')!==s){
        var w=document.createElement('div'); w.innerHTML=s; var node=w.firstChild; node.setAttribute('data-odavia-html',s);
        if(old) old.replaceWith(node);
        else { var t=foot.querySelector('.totals'); if(t) foot.insertBefore(node,t); else foot.insertBefore(node,foot.firstChild); }
      }
    }
    recommend(cart, root);
  }
  /* "Zur Kasse – {Summe}": keep the amount in the checkout buttons (drawer + /cart)
     in step with the cart. Dawn re-renders only the subtotal block on /cart, not the button. */
  function syncCheckoutTotals(cart){
    var els=document.querySelectorAll('.odavia-checkout-total');
    for(var i=0;i<els.length;i++){
      var el=els[i], cents=String(cart.total_price);
      if(el.getAttribute('data-cents')===cents) continue;
      var txt='– '+money(cart.total_price);
      if(el.textContent.replace(/\s+/g,'')!==txt.replace(/\s+/g,'')) el.textContent=txt;
      el.setAttribute('data-cents',cents);
    }
  }

  /* /cart: main-cart-footer server-renders an empty .odavia-cart-top slot with reserved
     height (only when the cart has items), so this only fills it and nothing below shifts. */
  function injectPage(cart){
    var page=document.querySelector('.cart__footer'); if(!page) return;
    var slot=page.querySelector('.odavia-cart-top');
    if(cart.item_count===0 || !enableProgress){ if(slot) slot.remove(); return; }
    var blocks=page.querySelector('.cart__blocks');
    var anchor=blocks?blocks.querySelector('.js-contents'):null;
    if(!slot){
      slot=document.createElement('div'); slot.className='odavia-cart-top';
      if(blocks && anchor && anchor.parentNode===blocks) blocks.insertBefore(slot,anchor);
      else if(blocks) blocks.insertBefore(slot,blocks.firstChild);
      else page.insertBefore(slot,page.firstChild);
    }
    setHTML(slot,progressHTML(cart));
  }

  var recoKey='';
  function recommend(cart, root){
    var host=root.querySelector('cart-drawer-items'); if(!host||!cart.items.length) return;
    var key=cart.items.map(function(i){return i.variant_id;}).sort().join(',');
    var existing=host.querySelector('.odavia-reco'); if(existing && recoKey===key) return; recoKey=key;
    var pid=cart.items[0].product_id; var inCart={}; cart.items.forEach(function(i){ inCart[i.product_id]=1; });
    fetch('/recommendations/products.json?product_id='+pid+'&limit=10&intent=related',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(d){
        /* Quick-add only for single-variant products (a multi-variant product would get
           its first variant, e.g. a size the customer never chose). Prefer a single-variant
           product; otherwise show a multi-variant one with an "Ansehen" link instead. */
        var list=(d&&d.products)||[]; var single=null, multi=null;
        for(var i=0;i<list.length;i++){
          var p=list[i], vs=p.variants||[];
          if(inCart[p.id] || !p.available || !vs.length) continue;
          if(vs.length===1){ if(vs[0].available){ single=p; break; } }
          else if(!multi){ multi=p; }
        }
        var pick=single||multi;
        var box=host.querySelector('.odavia-reco');
        if(!pick){ if(box) box.remove(); return; }
        var v=single?single.variants[0]:null;
        var url=pick.url||('/products/'+pick.handle);
        var name=shortTitle(pick.title);
        var img=(pick.featured_image||(pick.images&&pick.images[0])||'');
        if(img && img.indexOf('http')!==0 && img.indexOf('//')!==0) img='https:'+img;
        var from=(!v && pick.price_varies)?'ab ':'';
        var priceHTML=from+money(v?v.price:(pick.price_min!=null?pick.price_min:pick.price))+' <small class="odavia-reco__tax">inkl. MwSt.</small>';
        var action=v
          ? '<button type="button" class="odavia-reco__add" data-odavia-add="'+v.id+'" aria-label="'+esc(name)+' hinzufügen">Hinzufügen</button>'
          : '<a class="odavia-reco__add odavia-reco__view" href="'+esc(url)+'" aria-label="'+esc(name)+' ansehen">Ansehen</a>';
        var html='<p class="odavia-reco__h">Das könnte Ihnen gefallen</p>'+
          '<div class="odavia-reco__card">'+
            (img?'<a class="odavia-reco__media" href="'+esc(url)+'" tabindex="-1" aria-hidden="true"><img class="odavia-reco__img" src="'+esc(img)+'" alt="" loading="lazy" width="120" height="120"></a>':'')+
            '<div class="odavia-reco__body"><p class="odavia-reco__title">'+esc(name)+'</p><p class="odavia-reco__price">'+priceHTML+'</p></div>'+
            action+
          '</div>';
        if(!box){ box=document.createElement('div'); box.className='odavia-reco'; host.appendChild(box); }
        box.innerHTML=html;
      })
      .catch(function(){ var box=host.querySelector('.odavia-reco'); if(box) box.remove(); });
  }

  document.addEventListener('click', function(e){
    var btn=e.target && e.target.closest && e.target.closest('[data-odavia-add]'); if(!btn) return;
    e.preventDefault(); if(btn.disabled) return;
    btn.disabled=true; var label=btn.textContent; btn.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:parseInt(btn.getAttribute('data-odavia-add'),10),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:'/'})})
      .then(function(r){return r.json();})
      .then(function(res){
        if(res && res.sections && res.sections['cart-drawer']){
          var doc=new DOMParser().parseFromString(res.sections['cart-drawer'],'text/html');
          var fresh=doc.querySelector('#CartDrawer'); var cur=document.querySelector('#CartDrawer');
          if(fresh&&cur){ cur.innerHTML=fresh.innerHTML; }
          var bub=res.sections['cart-icon-bubble'];
          if(bub){ var bd=new DOMParser().parseFromString(bub,'text/html').querySelector('.shopify-section, #cart-icon-bubble, .cart-count-bubble');
            var tgt=document.querySelector('#cart-icon-bubble'); if(tgt&&bd) tgt.innerHTML=bd.innerHTML; } }
        recoKey=''; refresh();
      })
      .catch(function(){ btn.disabled=false; btn.textContent=label; });
  });

  var observers=[];
  function flushOwnMutations(){ observers.forEach(function(o){ o.takeRecords(); }); }
  var pending=false;
  function refresh(){ if(pending) return; pending=true;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
      .then(function(cart){ pending=false; injectDrawer(cart); injectPage(cart); syncCheckoutTotals(cart); flushOwnMutations(); })
      .catch(function(){ pending=false; }); }
  var timer; function schedule(){ clearTimeout(timer); timer=setTimeout(refresh,160); }
  function watch(el){ if(!el||!window.MutationObserver) return; var o=new MutationObserver(schedule); o.observe(el,{childList:true,subtree:true}); observers.push(o); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',refresh); else refresh();
  watch(document.getElementById('CartDrawer')||document.querySelector('cart-drawer'));
  watch(document.querySelector('cart-items'));
  document.addEventListener('change',function(e){ if(e.target&&e.target.closest&&e.target.closest('cart-items, cart-drawer-items')) schedule(); });
})();